export type AudioStartAnimation = 'entrance' | 'speaking'

export function getAudioStartAnimation(
  turnId: string | undefined,
  sequenceNumber: number,
): AudioStartAnimation {
  return turnId?.startsWith('greeting_') && sequenceNumber === 0
    ? 'entrance'
    : 'speaking'
}

export function shouldPreplayGreetingEntrance(
  isAvatarReady: boolean,
  hasGreetingRequest: boolean,
  isFirstGreetingAudioPending: boolean,
): boolean {
  return isAvatarReady && hasGreetingRequest && isFirstGreetingAudioPending
}
